import { defaultSilhouetteUrl } from '../constants';

export function getHasElectionStarted(meta) {
	return meta && !!meta.count && meta.count !== 0
}

export function getHasElectionFinished(meta) {
	return meta && (meta.isFinal || meta.count === 100)
}

export function getHasFirstRoundStarted(meta, roundIndex) {
	return getHasElectionStarted(meta) || roundIndex === 1
}

export function getIsElectionInProgress(meta) {
	return getHasElectionStarted(meta) && !getHasElectionFinished(meta)
}

export function getSubtitleByStatus(electionHasStarted, electionHasFinished) {
	if (electionHasFinished) {
		return ' - kompletní výsledky'
	} else if (electionHasStarted) {
		return ' - průběžné výsledky'
	}
	return ''
}

export function getCandidateFace(faces, candidateId) {
	return faces[candidateId]|| defaultSilhouetteUrl
}

/**
 * Return leaders from regions where elections has been already finished or
 * leaders who were elected in first round
 */
export function getRoundLeaders(leaders, roundIndex, meta){
	if (!getHasElectionStarted(meta[roundIndex])){
		const electedLeaders = {};

		for (const leaderId in leaders[roundIndex]) {
			const leader = leaders[roundIndex][leaderId];
			const electedInFirstRound = leader.elected[0] === 'ZVOLEN';

			if (electedInFirstRound) {
				electedLeaders[leaderId] = leader;
			}
		}
		return electedLeaders
	}

	return leaders[roundIndex];
}
